module.exports = __webpack_public_path__ + "c94e0172961a98c1273fc4641e6a1e4e.png";